import React, { useState } from 'react';
import { ViewUser } from './ViewUser';
import { UpdateUser } from './UpdateUser';
import { AccessPermission } from './AccessPermission';
import { DeleteUsers } from './DeleteUsers';
import { Transition } from "react-transition-group";

type Props = {
  openCloseState?: string;
  checkboxList?: Array<number>;
};

export const ManageUsersMenuOptions: React.FC<Props> = ({
  openCloseState,
  checkboxList,
}) => {
  const [openViewPopup, setOpenViewPopup] = useState<boolean>(false);
  const [openUpdatePopup, setOpenUpdatePopup] = useState<boolean>(false);
  const [openAccessPopup, setOpenAccessPopup] = useState<boolean>(false);
  const [openDeletePopup, setOpenDeletePopup] = useState<boolean>(false);

  return (
    <Transition in={openCloseState?.toLowerCase() === "open"} timeout={0} mountOnEnter>
      {transitionState => (
        <div className={`RightMenu ${openCloseState} ` + transitionState}>
          {checkboxList && checkboxList.length > 0 && (
            <div className="ItemsContainer">
              {/* View User */}
              {checkboxList.length === 1 && (
                <div className="Item" onClick={() => setOpenViewPopup(true)}>
                  <span>View User</span>
                </div>
              )}
              {openViewPopup && (
                <ViewUser
                  panelOpen={openViewPopup}
                  togglePanelOpen={setOpenViewPopup}
                  id={checkboxList[0]}
                />
              )}

              {/* Update User */}
              {checkboxList.length === 1 && (
                <div className="Item" onClick={() => setOpenUpdatePopup(true)}>
                  <span>Update User</span>
                </div>
              )}
              {openUpdatePopup && (
                <UpdateUser
                  panelOpen={openUpdatePopup}
                  togglePanelOpen={setOpenUpdatePopup}
                  id={checkboxList[0]}
                />
              )}

              {/* Access Permission */}
              {/* {checkboxList.length === 1 && (
                <div className="Item" onClick={() => setOpenAccessPopup(true)}>
                  <span>Access Permission</span>
                </div>
              )}
              {openAccessPopup && (
                <AccessPermission
                  panelOpen={openAccessPopup}
                  togglePanelOpen={setOpenAccessPopup}
                  id={checkboxList[0]}
                />
              )} */}

              {/* Delete user(s) */}
              <div className="Item" onClick={() => setOpenDeletePopup(true)}>
                <span>
                  Delete User{checkboxList && checkboxList.length > 1 ? 's' : ''}
                </span>
              </div>
              {openDeletePopup && (
                <DeleteUsers
                  panelOpen={openDeletePopup}
                  togglePanelOpen={setOpenDeletePopup}
                  addPluralTxt={checkboxList && checkboxList.length > 1}
                  ids={checkboxList}
                />
              )}
            </div>
          )}
        </div>
      )}
    </Transition>
  );
};
